(() => {
  if (window.kgshMediaBooted) return;
  window.kgshMediaBooted = true;
  const carousels = '[data-kgsh-carousel]';
  const galleries = '[data-kgsh-gallery]';
  const play = (video) => {
    const result = video.play();
    if (result && typeof result.catch === 'function') result.catch(() => {});
  };

  function initCarousel(root) {
    if (root.dataset.kgshCarouselReady === 'true') return;
    const track = root.querySelector('[data-kgsh-track]');
    const previous = root.querySelector('[data-kgsh-previous]');
    const next = root.querySelector('[data-kgsh-next]');
    if (!track || !previous || !next) return;
    const originals = [...track.querySelectorAll('.kgsh-carousel__item')];
    if (!originals.length) return;
    root.dataset.kgshCarouselReady = 'true';
    const count = originals.length;
    const cyclic = count > 1;
    let index = cyclic ? count : 0;
    let timer, settleTimer, busy = false, focused = false;
    let visible = false, pointerStart = null, editorSelected = false;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const clone = (item) => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        [...element.attributes].forEach(attribute => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify-editor')) element.removeAttribute(attribute.name);
        });
      });
      copy.querySelectorAll('video').forEach(video => {
        video.autoplay = false; video.controls = false; video.muted = true;
        video.removeAttribute('autoplay'); video.preload = 'none';
      });
      return copy;
    };
    if (cyclic) {
      const before = document.createDocumentFragment();
      originals.forEach(item => before.appendChild(clone(item)));
      track.prepend(before);
      originals.forEach(item => track.appendChild(clone(item)));
    }
    const slides = [...track.querySelectorAll('.kgsh-carousel__item')];
    root.classList.add('is-centered');
    root.classList.toggle('has-overflow', cyclic);
    track.removeAttribute('tabindex');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-roledescription', 'carousel');
    const auto = cyclic && root.dataset.kgshAuto !== 'false';

    const schedule = () => {
      clearTimeout(timer);
      if (!root.isConnected) return;
      if (auto && visible && !document.hidden && !focused && !editorSelected && pointerStart === null) {
        timer = setTimeout(() => { move(1); schedule(); }, Math.max(2000, Number(root.dataset.kgshInterval || 5)*1000));
      }
    };
    const center = (animate) => {
      const slide = slides[index];
      if (!slide) return;
      track.style.transition = animate && !motion.matches ? '' : 'none';
      track.style.transform = `translateX(${root.querySelector('.kgsh-carousel__shell').clientWidth / 2 - slide.offsetLeft - slide.offsetWidth / 2}px)`;
      slides.forEach((item, i) => item.classList.toggle('is-active', i === index));
      originals.forEach((item, i) => {
        item.setAttribute('aria-label', `Image ${i + 1} of ${count}`);
      });
    };
    const normalize = () => {
      index = count + ((index - count) % count + count) % count;
      center(false); busy = false;
    };
    const move = (direction) => {
      if (!cyclic || busy) return;
      busy = true; index += direction; center(true);
      clearTimeout(settleTimer);
      const duration = parseFloat(getComputedStyle(root).getPropertyValue('--kgsh-slide-ms')) || 700;
      settleTimer = setTimeout(normalize, motion.matches ? 0 : duration + 30);
    };
    previous.addEventListener('click', () => { move(-1); schedule(); });
    next.addEventListener('click', () => { move(1); schedule(); });
    const keyboardFocused = () => root.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
    root.addEventListener('focusin', () => { focused = keyboardFocused(); schedule(); });
    root.addEventListener('focusout', () => { setTimeout(() => { focused = keyboardFocused(); schedule(); }, 0); });
    root.addEventListener('pointerdown', () => { focused = false; schedule(); });
    track.addEventListener('pointerdown', event => { pointerStart = event.clientX; track.setPointerCapture(event.pointerId); clearTimeout(timer); });
    track.addEventListener('pointerup', event => {
      if (pointerStart !== null && Math.abs(event.clientX - pointerStart) > 40) move(event.clientX < pointerStart ? 1 : -1);
      pointerStart = null; schedule();
    });
    track.addEventListener('pointercancel', () => { pointerStart = null; schedule(); });
    track.addEventListener('lostpointercapture', () => { pointerStart = null; schedule(); });
    track.addEventListener('dragstart', event => event.preventDefault());
    root.addEventListener('keydown', event => {
      if (event.target.closest('video,input,select,textarea')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
    });
    root.addEventListener('shopify:block:select', event => {
      const selected = originals.findIndex(item => item === event.target || item.contains(event.target));
      if (selected >= 0) { editorSelected = true; index = (cyclic ? count : 0) + selected; center(false); schedule(); }
    });
    root.addEventListener('shopify:block:deselect', () => { editorSelected = false; schedule(); });
    const visibilityChange = () => {
      if (!root.isConnected) { clearTimeout(timer); document.removeEventListener('visibilitychange', visibilityChange); return; }
      schedule();
    };
    document.addEventListener('visibilitychange', visibilityChange);
    motion.addEventListener('change', schedule);
    const sizeObserver = new ResizeObserver(() => center(false));
    sizeObserver.observe(root.querySelector('.kgsh-carousel__shell'));
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    observer.observe(root);
    const unload = event => {
      if (!event.target.contains(root)) return;
      clearTimeout(timer); clearTimeout(settleTimer); sizeObserver.disconnect(); observer.disconnect();
      document.removeEventListener('visibilitychange', visibilityChange); motion.removeEventListener('change', schedule);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    requestAnimationFrame(() => center(false));
  }

  function updateSound(video) {
    const button = video.closest('.kgsh-ugc__item')?.querySelector('[data-kgsh-sound]');
    if (!button) return;
    button.setAttribute('aria-pressed', String(!video.muted));
    button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
    button.querySelector('span').textContent = video.muted ? '🔇' : '🔊';
  }

  function initGallery(root) {
    if (root.dataset.kgshGalleryReady === 'true') return;
    root.dataset.kgshGalleryReady = 'true';
    const videos = [...root.querySelectorAll('.kgsh-ugc__video')];
    const galleryAutoplay = root.dataset.kgshAutoplay === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayFor = (video) => {
      const mode = video.closest('.kgsh-ugc__item')?.dataset.kgshPlayback;
      return mode === 'autoplay' || (mode !== 'click' && galleryAutoplay);
    };

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      updateSound(video);
      const button = video.closest('.kgsh-ugc__item')?.querySelector('[data-kgsh-sound]');
      if (!button) return;
      button.addEventListener('click', () => {
        const unmute = video.muted;
        videos.forEach((other) => {
          if (other !== video) {
            other.muted = true;
            updateSound(other);
          }
        });
        video.muted = !unmute;
        if (unmute && video.paused && autoplayFor(video)) play(video);
        updateSound(video);
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting && autoplayFor(video) && !reducedMotion) {
          play(video);
        } else {
          video.pause();
          video.muted = true;
          updateSound(video);
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.05 });
    videos.forEach((video) => observer.observe(video));
  }

  function initReviewViewer(scope) {
    scope.querySelectorAll('[data-kgsh-review-src]').forEach(button => {
      if (button.dataset.kgshViewerReady) return;
      button.dataset.kgshViewerReady = 'true';
      button.addEventListener('click', () => {
        let dialog = document.querySelector('.kgsh-review-dialog');
        if (!dialog) {
          dialog = document.createElement('dialog');
          dialog.className = 'kgsh-review-dialog';
          dialog.setAttribute('aria-label', 'Customer review image');
          const close = document.createElement('button');
          close.type = 'button'; close.className = 'kgsh-review-dialog__close'; close.textContent = 'Close';
          const image = document.createElement('img');
          dialog.append(close, image); document.body.appendChild(dialog);
          close.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', event => {
            const rect = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
          });
          dialog.addEventListener('close', () => {
            if (dialog.kgTrigger?.isConnected) dialog.kgTrigger.focus();
            dialog.querySelector('img').removeAttribute('src');
          });
        }
        dialog.kgTrigger = button;
        const image = dialog.querySelector('img');
        image.src = button.dataset.kgshReviewSrc;
        image.alt = button.dataset.kgshReviewAlt || 'Customer review screenshot';
        dialog.showModal();
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll(carousels).forEach(initCarousel);
    scope.querySelectorAll(galleries).forEach(initGallery);
    initReviewViewer(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
